// extracted by mini-css-extract-plugin
export default {"sideNavNudge":"fouwhan4ElB","nudgeHeader":"fouSdpZU5Cu","nudgeTitle":"fouiK6Fx68m","nudgeClose":"fouOpByMpSU","nudgeBody":"foup4W3lKct","nudgeActions":"fou_UPiIeaF"};